import React, { ReactNode, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import * as Layer from '@/components/common/layer'
import { FadeTransition } from '@/components/common/transition/FadeTransition'
import { useTrans } from '@/hooks/useTrans'
import { IRootState } from '@/modules'
import { ILayerState, LAYER, layerActions } from '@/modules/common/layer'

import { Text } from './Text'

export enum NOTICE_ALERT_TYPE {
  ACTIVATION = 'ACTIVATION',
  RESET_DEBIT_CARD_PIN = 'RESET_DEBIT_CARD_PIN',
  CHANGE_DEBIT_CARD_PIN = 'CHANGE_DEBIT_CARD_PIN',
}

interface INoticeLayerProps {
  type: NOTICE_ALERT_TYPE
  children: ReactNode
}

const NoticeLayer = (props: INoticeLayerProps) => {
  const dispatch = useDispatch()
  const layerStatus = useSelector<IRootState, ILayerState>(state => state[LAYER])
  const isOpen = layerStatus[props.type]

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        dispatch(layerActions.close(props.type))
      }, 1000)
    }
  }, [dispatch, isOpen, props.type])

  return (
    <FadeTransition in={isOpen} isMountOnEnter>
      <Layer.Notice>
        <Text>{props.children}</Text>
      </Layer.Notice>
    </FadeTransition>
  )
}

export const NoticeLayerActivation = () => {
  const $ = useTrans()

  return (
    <NoticeLayer type={NOTICE_ALERT_TYPE.ACTIVATION}>
      {$('debitcard_mycard_main_activate_toast')}
    </NoticeLayer>
  )
}

export const NoticeLayerResetDebitCardPin = () => {
  const $ = useTrans()

  return (
    <NoticeLayer type={NOTICE_ALERT_TYPE.RESET_DEBIT_CARD_PIN}>
      {$('debitcard_mycard_main_resetpin_toast')}
    </NoticeLayer>
  )
}

export const NoticeLayerChangeDebitCardPin = () => {
  const $ = useTrans()

  return (
    <NoticeLayer type={NOTICE_ALERT_TYPE.CHANGE_DEBIT_CARD_PIN}>
      {$('debitcard_mycard_main_chngpin_toast')}
    </NoticeLayer>
  )
}
